export default __webpack_public_path__ + "static/media/logoSchneider.49b1b5eb.png";